import { Col, Image, Spinner } from "react-bootstrap";
import resumeImg from "../../../assets/images/library/resume.svg";
import downloadIcon from "../../../assets/images/library/download-icon.svg";
import "../../../assets/scss/components/templates/shimmer.scss";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faDownload } from "@fortawesome/free-solid-svg-icons";
const SingleResume = (props) => {
  const {
    level,
    resumeTitle,
    company,
    isLoading,
    resumeImg,
    handleResumeClick,
    singleResumeDownlaod,
    isDownloading,
  } = props;
  // const handleResumeClick = () => {
  //   console.log("clicked");
  //   // Navigate to resume detail page with optional parameters or state
  //   navigate(`/resume-details/1224242`);
  // };

  const handleDownload = () => {
    console.log("download");
  };

  return (
    <Col xl={3} lg={4} md={6}>
      <div className="position-relative resumes">
        {isLoading ? (
          <div className="loading resume-box">
            <div className="image-box shimmer"></div>
            <div className="resume-detail">
              <div className="content">
                <h6 className="level shimmer "></h6>
                <h5 className="heading-7 shimmer "></h5>
                <p className="company shimmer "></p>
              </div>
              <div className="download-icon shimmer "></div>
            </div>
          </div>
        ) : (
          <div className="final-resume-box">
            <div className="text-center" onClick={() => handleResumeClick()}>
              <Image src={resumeImg} className="resume-image" />
            </div>
            <div className="resume-detail">
              <div className="content" onClick={() => handleResumeClick()}>
                <h6 className="level">{level}</h6>
                <h5 className="heading-7">{resumeTitle}</h5>
                <p className="company">{company}</p>
              </div>
              {/* <div className="buttons">
                <div
                  className={`icon download ${isDownloading && "disable"}`}
                  onClick={() => singleResumeDownlaod()}
                >
                  {isDownloading ? (
                    <FontAwesomeIcon
                      icon={faSpinner}
                      spin
                      size="lg"
                      color="white"
                    />
                  ) : (
                    <Image src={downloadIcon} alt="Download" />
                  )}
                </div>
              </div> */}
              <div className="download-icon">
                <div
                  className={`icon download ${isDownloading ? "disable" : ""}`}
                  onClick={() => singleResumeDownlaod()}
                >
                  {isDownloading ? (
                    <FontAwesomeIcon
                      icon={faSpinner}
                      spin
                      size="lg"
                      color="white"
                    />
                  ) : (
                    <Image src={downloadIcon} alt="Download" />
                  )}
                </div>
                {/* <div
                  className={`icon download ${isDownloading && "disable"}`}
                  onClick={() => singleResumeDownlaod()}
                >
                  {isDownloading ? (
                    <FontAwesomeIcon
                      icon={faSpinner}
                      spin
                      size="lg"
                      color="white"
                    />
                  ) : (
                    <Image src={downloadIcon} alt="Download" />
                  )}
                </div> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </Col>
  );
};

export default SingleResume;
